import React, { useContext, useEffect } from 'react';
// import { MatxLogo } from 'components';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import useSettings from 'app/hooks/useSettings';
import { AppControlContext } from 'app/contexts/AppControlContext';
import Toggle from './Toggle';
import { View } from 'react-native';

const Brand = ({ children }) => {
  const classes = useStyles();
  const classes2 = useStyles2();
  const { settings } = useSettings();
  const leftSidebar = settings.layout1Settings.leftSidebar;
  const { mode } = leftSidebar;
  const { isAppControl, setIsAppControl } = useContext(AppControlContext)

  useEffect(() => {
    //console.log('brand', isAppControl)
  }, [isAppControl])

  return (
    <div className={clsx('', !isAppControl ? classes.brand : classes2.brand)}>
      <div className="flex items-center">
        {/* <MatxLogo /> */}
        {/* <span className={clsx({
            'text-18 ml-2 font-medium sidenavHoverShow': true,
            [classes.hideOnCompact]: mode === 'compact',
          })}
        >
          <span className={[classes.shop]}>Shop</span> for Eat & Group
      </span> */}
        <View style={{ width: "100%" }}>
          <img src={!isAppControl ? `${process.env.PUBLIC_URL}/assets/Shop/logo.svg` : `${process.env.PUBLIC_URL}/assets/Shop/logo_ssv_control.svg`} style={{ width: !isAppControl ? 104 : 108, height: 'auto', marginLeft: 'auto', marginRight: 'auto' }} />
          <div style={{ height: 5 }} />
          <div style={{ fontSize: 18, fontWeight: 'bold', textAlign: 'center', color: !isAppControl ? `` : `#414141` }}>{!isAppControl ? `Sales View` : `APP Control`}</div>
          {/* 店舗登録サイドナビに切り替え（大阪王将では必要ない） */}
          {/* <View style={{ position: 'absolute', right: 0, bottom: 0 }}>
            <Toggle
              onPress={() => setIsAppControl(!isAppControl)}
            />
        </View>*/}
        </View>
      </div>
      {/* <div
                className={clsx({
                    sidenavHoverShow: true,
                    [classes.hideOnCompact]: mode === 'compact',
                })}
            >
                {children || null}
            </div> */}
    </div >
  );
};

export default Brand;


const useStyles = makeStyles(({ palette, ...theme }) => ({
  brand: {
    padding: '20px 18px 20px 24px',
    // padding: '12px 18px 12px 24px',
    // backgroundColor: '#0A39D6',//shop for の部分
  },
  hideOnCompact: {
    display: 'none',
  },
  shop: {
    fontSize: 28,
  },
}));

const useStyles2 = makeStyles(({ palette, ...theme }) => ({
  brand: {
    padding: '20px 18px 40px 24px',
    // padding: '12px 18px 12px 24px',
    // backgroundColor: '#ffff00',//shop for の部分
  },
  hideOnCompact: {
    display: 'none',
  },
  shop: {
    fontSize: 28,
  },
}));